var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{staticClass:"shrink"},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.submittedTime))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }